import { StyledCol } from './style'

const Col = ({ children, className, ...restProps }) => {
  return (
    <StyledCol className={className} {...restProps}>
      {children}
    </StyledCol>
  )
}

export default Col
